'use_strict';

import $ from 'jquery';
import 'select2';

const select = {
  init: function() {

    $('select.select2').each(function() {
      const noResultText = $(this).data('no-results') || 'No results';
      $(this).select2({
        language: {
          noResults: function() {
            return noResultText;
          }
        }
      });

      // If select2 element has class "select2-search-autofocus"
      if($(this).hasClass('select2-search-autofocus')){
        // Add event listener for "open"
        $(this).on('select2:open', function(){
          // When opened, get search field and focus it if found
          const $searchfield = $('.select2-container--open .select2-search__field');
          $searchfield.get(0)?.focus();
        })
      }
    });

    $('select.select2-no-search').select2({
      minimumResultsForSearch: Infinity
    });

    // Selectboxes with class .goto-link should take user to another page
    $('.goto-link').on('change', function(e) {
      var selectedUrl = $(this).val();

      //Sample usage:
      //<select class="selectBoxIt goto-link" data-ga-event-params='{"category": "campaign-2014", "action": "tyre-selected", "label": "tyre-selection"}'>
      if($(this).data('ga-event-params')) {
        var gaParamsGiven = $(this).data('ga-event-params'),
          gaParams = {
            hitType: 'event', // Required
            eventCategory: gaParamsGiven.category, // Required
            eventAction: gaParamsGiven.action, // Required
            hitCallback: function() {
              location.href = selectedUrl;
            }
          };

        //optional
        if(gaParamsGiven.label) {
          gaParams.eventLabel = gaParamsGiven.label;
        }

        //optional
        if(gaParamsGiven.value) {
          gaParams.eventValue = gaParamsGiven.value;
        }

        if(window.ga) window.ga('send', gaParams);

        window.setTimeout(function() {
          location.href = selectedUrl;
        }, 100);

      } else {
        if($(this).hasClass('new-window')) {
          var popup = window.open(selectedUrl, '_blank');

          // browser blocked window.open on change event
          // use location.href instead
          if(!popup) {
            location.href = selectedUrl;
          } else {
            window.location.reload();
          }
        } else {
          location.href = selectedUrl;
        }
      }

    });
  }
};

export default select;
